import React, { useMemo } from 'react';
import { Input } from 'reactstrap';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import common from 'constants/common';
import classNames from 'classnames';
import AutoComplete from './autocomplete';
import DateInput from './dateInput';

const NewRow = ({ messageErrors, newRow: row, setRow, initialRow }) => {
  const handleSelectSearch = (item) => {
    const [name, route] = item.id.split('|').map((chunk) => chunk.trim());
    setRow({ ...row, name, route });
  };

  const isActive = useMemo(() => {
    if (!row.endDate) return true;
    const endDate = new Date(row.endDate);
    const now = new Date();
    return endDate >= now;
  }, [row.endDate]);

  return (
    <tr>
      <td className="table-column__input no-padding">
        <AutoComplete
          filter={{
            placeholder: 'Medication...',
            label: 'Medication name',
            id: 'name',
          }}
          handleClick={handleSelectSearch}
          handleReset={() => setRow(initialRow)}
        />
        {messageErrors.name ? (
          <div className="table-column__error">{messageErrors.name}</div>
        ) : null}
      </td>
      <td>
        <div
          className={classNames('activity-status', {
            'activity-status-normal': isActive,
            'activity-status-critical': !isActive,
          })}
        >
          {isActive ? 'Active' : 'Inactive'}
        </div>
      </td>
      <td className="ccm-datepicker-mobile-1">
        <DateInput
          date={row.startDate}
          onClear={() => {
            setRow({
              ...row,
              startDate: null,
            });
          }}
          onSelect={(date) => {
            setRow({
              ...row,
              startDate: format(
                date,
                common.dateFormats.priorAuthorizationAdmin,
              ),
            });
          }}
        />
        {messageErrors.startDate ? (
          <div className="table-column__error">{messageErrors.startDate}</div>
        ) : null}
      </td>
      <td className="ccm-datepicker-mobile-2">
        <DateInput
          date={row.endDate}
          onClear={() => {
            setRow({
              ...row,
              endDate: null,
            });
          }}
          onSelect={(date) => {
            setRow({
              ...row,
              endDate: format(date, common.dateFormats.priorAuthorizationAdmin),
            });
          }}
        />
        {messageErrors.endDate ? (
          <div className="table-column__error">{messageErrors.endDate}</div>
        ) : null}
      </td>
      <td className="table-column__input">
        <div>
          <div className="table-column__input-container">
            <Input
              plaintext
              bsSize="sm"
              defaultValue={row.duration}
              onChange={(e) =>
                setRow({
                  ...row,
                  duration: e.target.value,
                })
              }
            />
          </div>
        </div>
      </td>
      <td className="table-column__input">
        <div>
          <div className="table-column__input-container">
            <Input
              plaintext
              bsSize="sm"
              defaultValue={row.dosage}
              onChange={(e) =>
                setRow({
                  ...row,
                  dosage: e.target.value,
                })
              }
            />
          </div>
        </div>
      </td>
      <td className="table-column__input">
        <div>
          <div className="table-column__input-container">
            <Input
              plaintext
              bsSize="sm"
              value={row.route}
              onChange={(e) =>
                setRow({
                  ...row,
                  route: e.target.value,
                })
              }
            />
          </div>
        </div>
      </td>
      <td className="table-column__input">
        <div>
          <div className="table-column__input-container">
            <Input
              plaintext
              bsSize="sm"
              className="table-input input--text-plain"
              defaultValue={row.frequency}
              onChange={(e) =>
                setRow({
                  ...row,
                  frequency: e.target.value,
                })
              }
            />
          </div>
        </div>
      </td>
      <td className="table-column__input">
        <div>
          <div className="table-column__input-container">
            <Input
              plaintext
              bsSize="sm"
              className="table-input input--text-plain"
              defaultValue={row.note}
              onChange={(e) =>
                setRow({
                  ...row,
                  note: e.target.value,
                })
              }
            />
          </div>
        </div>
      </td>
    </tr>
  );
};

NewRow.propTypes = {
  messageErrors: PropTypes.shape(),
  newRow: PropTypes.shape(),
  initialRow: PropTypes.shape(),
  setRow: PropTypes.func,
};

export default NewRow;
